import {
  connect,
} from 'react-redux'
import { push } from 'react-router-redux'
import ETestingHome from '../../components/pages/eTestingHome'

import {
  loadHomePageAll,
  loadHomePageSide,
  loadLevels,
  loadCategory,
  loadCategoryExam,
  saveSection, loadListExam,
  loadPackage,
} from '../../actions'

import {
  HOME_SIDE_EP,
  HOME_ALL_EP,
  LEVEL_EP,
  INTEREST_EP,
  CATEGORY_EXAM, LIST_EXAM,
  PACKAGEPRODUCT,
} from '../../constant'

import {
  decodeQueryUrl,
} from '../../utils'

const mapStateToProps = ({
  pages,
  info,
  example: {
    packages,
    categories,
    listExam,
    allExam,
    popularExam,
    newExam,
  },
}, {
  location: {
    search,
  },
}) => {
  const {
    level,
    category,
  } = decodeQueryUrl(search)
  const isLevel = !!level
  const isCategory = !!category
  return {
    pages,
    level: isLevel ? level : '0',
    category: isCategory ? category : '0',
    params: search,
    categories,
    listExam,
    allExam,
    popularExam,
    newExam,
    packages,
    info,
  }
}

const mapDispatchToProps = dispatch => ({
  onLoadPage ({ levelId = 0, categoryId = 0, page = 1 }) {
    dispatch(loadHomePageAll(HOME_ALL_EP(levelId, categoryId, page)))
    dispatch(loadHomePageSide(HOME_SIDE_EP(levelId, categoryId)))
  },
  onLoadMenu () {
    dispatch(loadLevels(LEVEL_EP))
    dispatch(loadCategory(INTEREST_EP))
  },
  onloadCategoryExam () {
    dispatch(loadCategoryExam(CATEGORY_EXAM))
    dispatch(loadPackage(PACKAGEPRODUCT))
  },
  onloadListExam (slugName) {
    dispatch(loadListExam(LIST_EXAM(slugName)))
  },

  onSaveSection (data, pathName) {
    dispatch(saveSection(data))
    dispatch(push(pathName))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ETestingHome)



// WEBPACK FOOTER //
// ./src/containers/pages/ETestingHome.js